module.exports = __webpack_public_path__ + "img/Monoscan Groupage .2 (mid).4f6b2ca8.jpg";